import React, { useContext } from 'react';
import { BiReceipt, BiWalletAlt, BiCog, BiUserCheck } from "react-icons/bi";
import { PiTarget } from "react-icons/pi";

import history from '../../../history';
import ContentHeader from '../contentHeader';
import { Context } from '../../../context/AuthContext';
import './sidebar.css';

function SideBar(props) {
    const { userData } = useContext(Context);
     // Verifica permissões
    const isAdmin = userData?.roles?.includes('admin');
    const isCallCenter = userData?.roles?.includes('call-center');
    const isSupervisor = userData?.roles?.includes('supervisor');
    const hasAccess = isAdmin || isCallCenter || isSupervisor;

    function go(page) {
        history.push(page)
    }

    const isArc = process.env.REACT_APP_BUILD === 'arc';

    return (
        <div className={`topbar ${isArc ? 'arc-version' : ''}`}>
            <div className="topbar-container">
                <div className="topbar-header">
                    <img className={process.env.REACT_APP_BUILD === 'arc' ? 'arc' : ''} src={process.env.PUBLIC_URL + `/${process.env.REACT_APP_BUILD}.png`} />
                </div>
                <div className="topbar-menu">
                    <ul>
                        <li className={props.page === 'customers' ? 'active' : ''} onClick={() => go("/customers")} >
                            <BiReceipt size="15px" />
                            <span>Clientes</span>
                        </li>
                        <li className={props.page === 'sales-goals' ? 'active' : ''} onClick={() => go("/sales-goals")} >
                            <PiTarget size="19px" />
                            <span>Metas de Vendas</span>
                        </li>
                        {hasAccess && (
                            <li className={props.page === 'interested-customers' ? 'active' : ''} onClick={() => go("/interested-customers")} >
                                <BiUserCheck size="17px" />
                                <span>Interessados</span>
                            </li>
                        )}
                        {/* <li className={props.page === 'wallets' ? 'active' : ''} onClick={() => go("/wallets")} >
                            <BiWalletAlt size="15px" />
                            <span>Carteiras</span>
                        </li> */}
                        <li className={props.page === 'configs' ? 'active' : ''} onClick={() => go("/configs")}  >
                            <BiCog size="15px" />
                            <span>Configurações</span>
                        </li>
                    </ul>
                </div>
                <div className="topbar-content-header">
                    <ContentHeader title={props.title} icon={props.icon} />
                </div>
            </div>
        </div>
    )
}

export default SideBar;